import { render, staticRenderFns } from "./answerQuestionsDetail.vue?vue&type=template&id=22f3aa6a&scoped=true&"
import script from "./answerQuestionsDetail.vue?vue&type=script&lang=js&"
export * from "./answerQuestionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./answerQuestionsDetail.vue?vue&type=style&index=0&id=22f3aa6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3aa6a",
  null
  
)

export default component.exports